import React, { Component } from "react";

class LearnMore extends Component {
  render() {
    return (
      <div className="absolute mt-24 w-full">
        <h1 className="text-2xl font-bold text-center my-8">How Seemy Works</h1>
      </div>
    );
  }
}

export default LearnMore;